var RwAjaxVote = (function () {

  // funzione php: inc/riservata/vote/func-ajax-vote.php
  // La security è definita in inc/enqueue.php da rw_ajax_obj
  var vota = function (post_id, post_type, blog_id, vote_cat, vote_table, concorso_id) {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_vote',
        security : rw_ajax_obj.ajax_nonce,
        post_id : post_id,
        post_type : post_type,
        blog_id : blog_id,
        vote_cat : vote_cat,
        vote_table : vote_table,
        concorso_id : concorso_id
      },
      beforeSend: function() {
      },
      success : function( response ) {
        // response = $.parseJSON(response);
        // console.log(response);
        // console.log('risposta');
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
      }
    });

  };


  var start = function () {

    // console.log('ajax-vote started');
    // reset stato pulsante vote
    $('#start-vote i').removeClass('fas').addClass('fal');

    // ricavo array dati categorie di voto
    const votecats = JSON.parse( atob( document.getElementById('griglia').dataset.voteCats ) );


    // al click sull'icona di voto esplodo lista categorie
    $('.vote-button i').click(function(e){
      e.preventDefault();

      var vote_table = $('#griglia').data('store');
      var concorso_id = $('#griglia').data('concorso');

      var post_id = $(this).closest('.vote-button').data('id');
      var post_type = $(this).closest('.vote-button').data('type');
      var blog_id = $(this).closest('.vote-button').data('blog');
      var vote_cat = $(this).closest('.iso-list').data('cat-id');

      // solo se non è già stato espresso un voto
      // oppure solo se voglio togliere il voto espresso
      if(
        !$(this).closest('.iso-list').find('.iso-item').hasClass('voted') ||
        $(this).closest('.iso-item').hasClass('voted')
      ){

        vota(post_id, post_type, blog_id, vote_cat, vote_table, concorso_id);

        // toggle dell'icona cuore piena/vuota solo per la categoria corrente
        var $currentIsoList = $(this).closest('.iso-list');
        var vote_btn = $currentIsoList.find('.vote-' + post_type + '-' + post_id + ' i');
        if(vote_btn.hasClass('fal')){
          vote_btn.removeClass('fal').addClass('fas');
        } else {
          vote_btn.removeClass('fas').addClass('fal');
        }

        // aggiungo la classe voted e categoria votata solo all'elemento nella categoria corrente
        var $article = $currentIsoList.find('.' + post_type + '-' + post_id);
        $article.toggleClass('voted').addClass('cv-' + vote_cat);

      }


    });

  };


  return {
    start : start
  }


})();
